import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const IconItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  img {
    max-height: 32px;
    max-width: fit-content;
  }

  span {
    color: ${color.copy[200]};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    max-width: ${(props) => (props?.length > 3 ? "122px" : "90px")};
  }
`

export const IconItems = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`

export const BulletItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  span {
    color: ${color.copy[200]};
    font-size: 18px;
    font-style: normal;
    font-weight: 350;
  }
`

export const BulletItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const BulletItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ isTalkToSales }) =>
    isTalkToSales &&
    `
      margin-bottom: -16px;
      padding-left: 12px;
      ${ListHeading} {
        font-size: 16px;
        font-weight: 800;
      };
      ${BulletItems} {
        gap: 8px;
        ${BulletItem} {
          span {
            font-size: 16px;
          }
        };
      };
  `};
`

export const ListHeading = styled.p`
  color: ${color.common.white};
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  margin: 0;
`

export const TextItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h3 {
    color: ${color.common.white};
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    margin: 0;

    .emoji {
      font-size: 24px;
      vertical-align: middle;
    }
  }

  span {
    color: ${color.copy[200]};
    font-size: 16px;
    font-style: normal;
    font-weight: 350;
  }
`

export const TextItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const TextItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ isTalkToSales }) =>
    isTalkToSales &&
    `
      margin-bottom: -16px;
      ${TextItems} {
        padding-left: 12px;
        gap: 8px;
      };
  `};
`

export const IconItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Eyebrow = styled.span`
  color: ${color.primary[200]};
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: 20px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
`

export const HeadingText = styled.h1`
  color: ${color.common.white};
  font-size: ${(props) => (props?.standard ? "30px" : "36px")};
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  margin: 0;

  span {
    color: ${color.primary[200]};
  }

  @media (min-width: 992px) {
    font-size: ${(props) => (props?.standard ? "36px" : "48px")};
  }

  @media (min-width: 1280px) {
    font-size: ${(props) => (props?.standard ? "48px" : "60px")};
  }
`

export const SubheadingText = styled.p`
  color: ${color.copy[200]};
  font-size: 20px;
  font-style: normal;
  font-weight: 350;
  margin: 0;
`

export const IconTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .package-icon {
    width: 48px;
    height: 48px;

    @media (min-width: 1366px) {
      width: 88px;
      height: 88px;
    }
  }

  @media (min-width: 992px) {
    gap: 12px;

    .package-icon {
      width: ${(props) => (props?.main ? "64px" : "56px")};
      height: ${(props) => (props?.main ? "64px" : "56px")};
    }
  }

  @media (min-width: 1366px) {
    gap: 16px;
  }
`

export const StandardTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .package-icon {
    max-width: 70px;
    height: auto;
  }

  @media (min-width: 1280px) {
    gap: 24px;
  }
`

export const SupportSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ isTalkToSales }) =>
    isTalkToSales &&
    `
      padding-left: 12px;
      @media (min-width: 992px) {
        margin-bottom: -16px;
      }
      ${ListHeading} {
        font-size: 16px;
        font-weight: 800;
      };
  `};

  @media (min-width: 768px) {
    margin: 0;
  }
`

export const SupportSectionContent = styled.div`
  color: ${color.copy["200"]};
  font-size: 16px;
  font-weight: 350;
  p {
    margin: 0;
  }
`

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  color: ${color.common.white};

  @media (min-width: 992px) {
    gap: 48px;
  }

  @media (min-width: 1280px) {
    gap: 32px;
  }
`

export const FormSubtitle = styled.p`
  color: ${color.copy[700]};
  font-size: 16px;
  font-style: normal;
  font-weight: 350;
  margin: 0;
`

export const FormTitle = styled.h3`
  color: ${color.oxfordBlue[900]};
  font-size: 24px;
  font-style: normal;
  font-weight: 900;
  margin: 0;
`

export const FormHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FormCard = styled.div`
  border-radius: 16px;
  background: ${color.common.white};
  box-shadow: 0 4px 6px -2px rgba(16, 24, 40, 0.05),
    0 12px 16px -4px rgba(16, 24, 40, 0.1);
  padding: 32px 16px;

  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (min-width: 992px) {
    padding: 32px;
  }

  @media (min-width: 1024px) {
    width: 570px;
  }
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  z-index: 1;

  @media (min-width: 992px) {
    gap: 48px;
  }

  @media (min-width: 1280px) {
    gap: 32px;
  }

  .hs-form {
    fieldset {
      display: flex;
      align-items: center;
      flex-direction: column;
      max-width: 100%;

      @media (min-width: 576px) {
        gap: 16px;
        flex-direction: row;
      }
    }
    .hs-richtext {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: ${color.gray[700]};
      .hs-form-required {
        color: ${color.common.required};
      }
    }
    .hs-form-field {
      margin: 0 0 16px;
      width: 100% !important;
      .hs-input[type="text"],
      .hs-input[type="email"],
      .hs-input[type="tel"],
      select,
      textarea {
        background: ${color.common.white};
        border: 1px solid ${color.gray[300]};
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
        border-radius: 8px;
        padding: 10px 14px;
        width: 100%;
        font-weight: 350;
        font-size: 16px;
        line-height: 24px;
        color: ${color.gray[900]};
        &.error {
          border: 1px solid ${color.common.error};
        }
        &:focus {
          border: 1px solid ${color.primary[400]};
          box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05),
            0 0 0 4px ${color.primary[50]};
        }
        &:focus-visible {
          outline: ${color.primary[400]} auto 1px;
          box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05),
            0 0 0 4px ${color.primary[50]};
        }
        #placeholder {
          font-weight: 350;
          font-size: 16px;
          line-height: 24px;
          color: ${color.gray[500]};
        }
      }
      label {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: ${color.gray[700]};
        .hs-form-required {
          color: ${color.common.required};
        }
      }
      &.hs-fieldtype-booleancheckbox {
        .input {
          .inputs-list {
            list-style: none;
            margin-right: 0;
            margin-bottom: 0;
            padding-inline-start: 0;
            li {
              input {
                background: ${color.common.white};
                border: 1px solid ${color.gray[300]};
                border-radius: 4px;
                margin-right: 8px;
                width: max-content;
              }
              label {
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: ${color.gray[700]};
                margin-bottom: 0;
              }
            }
          }
        }
      }
      &.hs-fieldtype-select {
        select {
          font-weight: 350;
          font-size: 16px;
          line-height: 24px;
          color: ${color.gray[500]};
        }
      }
      div.input {
        margin: 0;
        .hs-input {
          width: 100%;
        }
      }
    }
    .legal-consent-container .field.hs-form-field {
      margin: 0;
    }
    .legal-consent-container {
      p {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: ${color.gray[700]};
      }
    }
    .legal-consent-container .hs-form-booleancheckbox-display > span {
      display: flex;
      align-items: center;
    }
    .legal-consent-container .hs-form-booleancheckbox-display > input {
      margin-top: 4px;
    }

    .hs-submit {
      input {
        width: 100%;
        padding: 11px 20px;
        background: ${color.primary[200]};
        border: 1px solid ${color.primary[200]};
        border-radius: 40px;
        font-weight: 900;
        font-size: 14px;
        line-height: 20px;
        color: ${color.copy[900]};
        height: 42px;
        margin-top: 16px;
        &:hover {
          background: ${color.primary[400]};
        }
        &:focus {
          background: ${color.primary[200]};
          border: 2px solid ${color.common.purple};
          color: ${color.common.white};
        }
        &:active {
          background: ${color.primary[900]};
        }
      }
    }
    .hs-error-msgs {
      list-style: none;
      padding-left: 0;
      margin-top: 3px;
    }
  }

  .grecaptcha-badge {
    visibility: visible;
  }

  .form-columns-3 {
    gap: 24px;

    > div {
      padding: 8px 16px;
      border-radius: 8px;
      border: 1px solid ${color.gray["300"]};
      min-height: 178px;
      display: flex;
      flex-direction: column-reverse;
      gap: 16px;
      align-items: center;
      justify-content: space-between;

      @media (min-width: 992px) {
        min-height: 210px;
      }

      span {
        text-align: center;
      }
    }
  }

  .form-columns-3 .inputs-list label.hs-form-booleancheckbox-display {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  .hs-form .hs-error-msgs {
    display: none;
  }

  .legal-consent-container {
    display: flex;
    .hs-error-msgs label {
      display: none;
    }
    .hs-form-booleancheckbox {
      span {
        display: none !important;
      }
    }
  }
`

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 32px;
  width: 100%;

  @media (min-width: 992px) {
    gap: 48px;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  @media (min-width: 1366px) {
    gap: 100px;
  }
`

export const HeroContainer = styled.div`
  max-width: 1170px;
  margin: 0 auto;
  padding: 50px 30px;

  @media (min-width: 1200px) {
    padding: 0;
  }
`

export const CornerImage = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  max-width: 118px;

  @media (min-width: 768px) {
    max-width: 264px;
  }
`

export const HeroSignUpSection = styled.section`
  position: relative;
  margin-top: 150px;
  padding: 40px 0 145px;

  background: radial-gradient(
    350% 95% at 48% 0%,
    #000c30 0%,
    #000c30 99.99%,
    #ffffff 100%
  );

  @media (min-width: 768px) {
    padding-bottom: 175px;
    background: radial-gradient(
      170% 95% at 48% 0%,
      #000c30 0%,
      #000c30 99.99%,
      #ffffff 100%
    );
  }

  @media (min-width: 1024px) {
    padding: 56px 0 167px;
    background: ${(props) => `url(${props?.background})`} no-repeat center
      bottom / cover;
  }

  @media (min-width: 1280px) {
    padding: 96px 0 167px;
  }
`
